import { CommonModule } from '@angular/common';
import { Compiler, Component, Injectable, ModuleWithComponentFactories, NgModule } from '@angular/core';

@Injectable()
export class DynamicBuilderUtil {
    constructor(private compiler: Compiler) {}

    public createComponentFactorySync(template: string, clazz?: any) {
        const dynamicComponent = this.getDynamicBuilderUtilComponent(template, clazz);
        const module: ModuleWithComponentFactories<any> = this.getDynamicBuilderUtilModule(dynamicComponent);

        return (<any>module.componentFactories).find(f => f.componentType === dynamicComponent);
    }

    private getDynamicBuilderUtilComponent = (template, clazz) => {
        const metadata = { template, selector: 'at-dynamic', inputs: ['data: data'] };

        return Component(metadata)(clazz || class DynamicBuilderUtilComponent {});
    };

    private getDynamicBuilderUtilModule(dynamicComponent) {
        @NgModule({ imports: [ CommonModule ], declarations: [ dynamicComponent ] })
        class DynamicBuilderUtilModule {}

        return this.compileModule(DynamicBuilderUtilModule);
    }

    private compileModule(module) {
        return this.compiler.compileModuleAndAllComponentsSync(module);
    }
}
